<template>
    <div class="darkgrey_color text-start">
        <!-- Informations de départ -->
        <span v-if="pris_depart">
            Départ : <b>{{ depart }} | </b>
        </span>
        <span v-else-if="heure_depart">
            Départ prévu : <b>{{ runner.statut_course.heure_depart_theorique }} | </b>
        </span>

        <!-- Informations de la course -->
        {{ $t("course") }} : <b>{{ runner.identite.course }} <span v-if="runner.identite.batch"> - {{
            runner.identite.batch }}</span> | </b>
        {{ $t("categorie") }} : <b>{{ runner.identite.cat }} | </b>
        {{ $t("club") }} : <b>{{ clubDisplay }}</b>
    </div>
</template>

<script>
export default {
    name: 'SubEnteteCoureur',

    props: {
        runner: {
            type: Object,
            required: true
        }
    },

    computed: {
        depart() {
            return this.runner.statut.heure_depart;
        },

        heure_depart() {
            return this.runner.statut_course.heure_depart;
        },

        pris_depart() {
            return this.runner.statut_course.start && this.runner.statut.pris_depart;
        },

        clubDisplay() {
            return this.runner.identite.club.length > 0 ? this.runner.identite.club : '-';
        }
    }
}
</script>

<style lang="scss" scoped></style>
